"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = void 0;
var react_1 = require("react");
var axios_1 = require("./axios");
function useFetch(url, params) {
    var options = {
        method: 'GET',
        url: url,
        params: params,
    };
    var _a = (0, axios_1.useAxios)(options), fetch = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error;
    (0, react_1.useEffect)(function () {
        fetch();
    }, []);
    return [data, loading, error];
}
exports.useFetch = useFetch;
//# sourceMappingURL=fetch.js.map